import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import Utils from 'src/app/utils';

@Component({
  selector: 'app-monitoring-validation',
  templateUrl: './monitoring-validation.component.html',
  styleUrl: './monitoring-validation.component.scss'
})
export class MonitoringValidationComponent {

  workers : any;

  view : any;
  sort = 'name';
  monitor = 'all';
  group = 'all';
  search = '';
  errors_only = false;

  groups:any = [];

  u = Utils;

  pagination = { page: 1, pageSize: 1, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, public transloco: TranslocoService) { }

  ngOnInit(): void {

    this.pagination.page = 1;
    this.getWorkers();

  }

  getWorkers(){

    let filter = {
      sort: this.sort,
      monitor: this.monitor,
      group: this.group,
      search: this.search,
      page: this.pagination.page,
      expand: 'arc',
      pagesize: 500
    }

    //console.log('filter', filter);

    this.okService.get("workers",filter)
    .subscribe((data) => {


      this.workers = data.body;
      this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;
      this.groups = [{id:'all',name:'All Workers'},{id:'none',name:'No Group'}].concat(this.okService.groups);

      //console.log(this.workers);
      
    });


  }

  changePage(){
    //console.log('page',this.okService.pagination.page);
    this.getWorkers();
  }

  updateFilter(){
      this.getWorkers();
  }

}
